import React, { createRef, RefObject } from 'react';
import { OverlayTrigger } from 'react-bootstrap';
import { Popover } from 'components/popover/Popover';
import parse from 'html-react-parser';
import { PopoverStickOnHoverPropTypes } from 'components/popover/PopoverStickOnHoverPropTypes';

type StateType = {
  showPopover: boolean,
  isHovered: boolean,
};

type PropsType = PopoverStickOnHoverPropTypes & {
  children: React.ReactElement;
  popoverProps?: object,
};

class PopoverStickOnHover extends React.Component<PropsType, StateType> {
  refChildren: RefObject<HTMLElement>;

  constructor(props) {
    super(props);

    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);

    this.state = {
      showPopover: false,
      isHovered: false,
    };

    const { refChildren } = this.props;
    this.refChildren = refChildren || createRef<HTMLElement>();
  }

  componentDidUpdate() {
    const {
      isHovered,
      showPopover,
    } = this.state;
    const { text } = this.props;
    if (isHovered && !showPopover && text) {
      this.show();
    }
  }

  handleMouseEnter() {
    this.setState({ isHovered: true });

    const { text } = this.props;
    if (!text) {
      return;
    }
    this.show();
  }

  handleMouseLeave() {
    this.hide();
  }

  getContainer(): HTMLElement {
    if (!(this.refChildren.current instanceof HTMLElement)) {
      return null;
    }

    return this.refChildren.current.closest('.modal-content');
  }

  show() {
    this.setState({ showPopover: true });
  }

  hide() {
    this.setState({ showPopover: false });
    this.setState({ isHovered: false });
  }

  render() {
    const {
      text,
      children,
      placement,
      onExited,
      refChildren,
      asHtml,
      popoverProps,
    } = this.props;
    const { showPopover } = this.state;

    const newChildren = React.cloneElement(children, {
      onMouseEnter: this.handleMouseEnter,
      onMouseLeave: this.handleMouseLeave,
      ref: refChildren ? null : this.refChildren,
    });

    const popover = (
      <Popover
        id="popover"
        text={asHtml ? parse(text as string) : text}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        {...popoverProps}
      />
    );

    // noinspection RequiredAttributes
    return (
      <>
        <OverlayTrigger
          show={showPopover}
          placement={placement}
          overlay={popover}
          onExited={onExited}
          container={this.getContainer()}
          flip
        >
          {newChildren}
        </OverlayTrigger>
      </>
    );
  }
}

export { PopoverStickOnHover };
